import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {cardTypeToName} from '../../../campaignSetupAgent.config';

/**
 * Get the instructions for the prompt to card model agent
 * @param config {
  cardType: The type of the card to translate to
  cardId: an existing card id, if it is provided, the base instructions will be updated to include the existing card details
  cardSpecificInstructions?: instructions specif to the card, like - find creatives using tool, or search for feew using tool
}
 * @returns the instructions for the prompt to card model agent
 */
export default function getPromptToCardAgentInstructions({
  cardType,
  cardId,
  cardSpecificInstructions,
}: {
  cardType: NodeType;
  cardId: number;
  cardSpecificInstructions?: string;
}) {
  const instructions = [
    `You are an expert at ${cardId ? 'updating' : 'creating'} a card of type ${
      cardTypeToName[cardType]
    } which is a single card in an ad decisiong tree.
Translate natural language requests into structured card configuration.
There will be no interaction with the user, its only the assistant message and tool calls.
=== What is an ad decision tree ===
A decision tree is a structure made up of cards connected by outputs.
It starts with a single root card called the 'Campaign Card'.
Each card in the tree always selects an output to determine the next card in the flow,
and some cards also choose an ad element to add to the ad context.
The flow continues through the cards until it reaches a leaf card,
called the 'Creative Card,' which has no further outputs.`,
  ];

  if (cardSpecificInstructions) {
    instructions.push(`### ${cardTypeToName[cardType]} instructions: ${cardSpecificInstructions}`);
  }

  return instructions.join('\n');
}
